/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ELBHealthCheck } from '../model';
// @ts-ignore
import { NagiosHealthCheck } from '../model';
/**
 * HealthcheckApi - axios parameter creator
 * @export
 */
export const HealthcheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * N/A
         * @summary ELB Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckElbRetrieve: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/healthcheck/elb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * N/A
         * @summary Nagios Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckRetrieve: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/healthcheck/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthcheckApi - functional programming interface
 * @export
 */
export const HealthcheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthcheckApiAxiosParamCreator(configuration)
    return {
        /**
         * N/A
         * @summary ELB Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthcheckElbRetrieve(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELBHealthCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthcheckElbRetrieve(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * N/A
         * @summary Nagios Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthcheckRetrieve(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NagiosHealthCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthcheckRetrieve(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthcheckApi - factory interface
 * @export
 */
export const HealthcheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthcheckApiFp(configuration)
    return {
        /**
         * N/A
         * @summary ELB Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckElbRetrieve(aaSource?: string, options?: any): AxiosPromise<ELBHealthCheck> {
            return localVarFp.healthcheckElbRetrieve(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * N/A
         * @summary Nagios Healthcheck
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckRetrieve(aaSource?: string, options?: any): AxiosPromise<NagiosHealthCheck> {
            return localVarFp.healthcheckRetrieve(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for healthcheckElbRetrieve operation in HealthcheckApi.
 * @export
 * @interface HealthcheckApiHealthcheckElbRetrieveRequest
 */
export interface HealthcheckApiHealthcheckElbRetrieveRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof HealthcheckApiHealthcheckElbRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for healthcheckRetrieve operation in HealthcheckApi.
 * @export
 * @interface HealthcheckApiHealthcheckRetrieveRequest
 */
export interface HealthcheckApiHealthcheckRetrieveRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof HealthcheckApiHealthcheckRetrieve
     */
    readonly aaSource?: string
}

/**
 * HealthcheckApi - object-oriented interface
 * @export
 * @class HealthcheckApi
 * @extends {BaseAPI}
 */
export class HealthcheckApi extends BaseAPI {
    /**
     * N/A
     * @summary ELB Healthcheck
     * @param {HealthcheckApiHealthcheckElbRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthcheckApi
     */
    public healthcheckElbRetrieve(requestParameters: HealthcheckApiHealthcheckElbRetrieveRequest = {}, options?: any) {
        return HealthcheckApiFp(this.configuration).healthcheckElbRetrieve(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * N/A
     * @summary Nagios Healthcheck
     * @param {HealthcheckApiHealthcheckRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthcheckApi
     */
    public healthcheckRetrieve(requestParameters: HealthcheckApiHealthcheckRetrieveRequest = {}, options?: any) {
        return HealthcheckApiFp(this.configuration).healthcheckRetrieve(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
